import { BASE_URL } from './endpoints'
import { post, get, del, patch } from './https'

export const createPartner = (data: {
  name: string
  address: string
}): Promise<unknown> => {
  return post(`${BASE_URL}/super/partners`, data, null)
}

export const getPartners = (): Promise<unknown> => {
  return get(`${BASE_URL}/super/partners`)
}

export const deletePartner = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/super/partners/${id}`, null)
}

export const updatePartner = (data: {
  name: string
  address: string
},id:string): Promise<unknown> => {
  return patch(`${BASE_URL}/super/partners/${id}`, data, null)


}


export const reCreatePartnerApiKey = (
 id:string): Promise<unknown> => {
  return patch(`${BASE_URL}/super/partners/${id}/recreate-api-key`, null)

  
}

export const fileUpload = ({
  file,
  category,
}: {
  file: File
  category: string
}): Promise<unknown> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('category', category)

  return post(`${BASE_URL}/files/upload/`, formData, null)
}
